import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ClientCompanyModel } from 'src/Models/ClientCompanyModel';
import { AdminUserType } from 'src/Models/Common';
import { BriefingProcessingReportFilterModel, BriefingReportModel } from 'src/Models/ReportModel';
import { ReportService } from 'src/Services/report.service';
import { CheckAuth } from 'src/Services/utility.service';
import { UpdatesService } from 'src/Services/updatesService';
import * as FileSaver from 'file-saver';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { BriefingProcessingReportModel } from 'src/Models/BriefingProcessingReportModel';
import { StateMasterService } from 'src/Services/state-master.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-processing-reports',
  templateUrl: './processing-reports.component.html',
  styleUrls: ['./processing-reports.component.css']
})
export class ProcessingReportsComponent implements OnInit {
  
  tokenKey: string = '';
  filterModel = new BriefingProcessingReportFilterModel();
  briefingReports = new Array<BriefingReportModel>();
  dropdownListYears = new Array<{ id: number, text: string }>();
  selectedYear: any;
  dropdownSettingsYear = {};
  dropdownListMonth = new Array<{ id: number, text: string }>();
  selectedMonth: any;
  dropdownSettingsMonth = {};
  clientCompanyList = new Array<ClientCompanyModel>();
  selectedCompany: any;
  dropdownSettingsCompany = {};
  loginuserID: any;
  isloading = false;
  SelectedTool = '';
  systemUserCondition: string = '';

  rangeDates: Date[] = [];
  fromDateFilter: string = '';
  toDateFilter: string = '';

  documentForm = new FormGroup({
    rangeDates: new FormControl(),
  });

  listOfData: BriefingProcessingReportModel[];
  listOfDataExport: BriefingProcessingReportModel[];
  productId: number = 1;

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = []; 

  currentPage: number = 1;
  totalRecordCount: number = -1;
  isAscending: boolean = false
  upDowEmailDateCSS: string = '';
  upDowTitleCSS: string = '';
  upDowSourceDateCSS: string = '';
  upDowAcquiredDateCSS: string = '';

  constructor(private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly reportService: ReportService, 
    private readonly toastrService: ToastrService,
    private readonly stateMasterService: StateMasterService,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Processing Report');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    if (AdminUserType.systemadmin == this.sessionStorageService.getAdminTypeId())
      this.systemUserCondition = 'null'
    else
      this.systemUserCondition = '  (CompanyId IN (Select CompanyId From [SystemUserCompany] Where [SystemUserCompany].UserId = ' + this.loginuserID + '))';
      
    this.filterModel.orderBy='UpdateDate';
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
  }

  ngOnInit() {
    this.movetotop();
    this.dropdownSettingsYear = {
      singleSelection: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Year available',
      primaryKey: 'id',
      labelKey: 'text',
      text: 'Select Year',
    };
    this.dropdownSettingsMonth = {
      singleSelection: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No month available',
      primaryKey: 'id',
      labelKey: 'text',
      text: 'Select Month',
    };
    
    this.setCurrentMonthDateRange();
    this.GetStateData();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.stateMasterService.getStateV2(this.tokenKey, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select Jurisdiction(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No Jurisdiction available',
          showCheckbox: true
        };
      }, error => {
        console.log(error);
      })
  }

  getBriefingProcessingReport() {
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.isExport=false;
    this.reportService.BriefingProcessingReportV2(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfData = data.briefingReports;

          if (this.listOfData.length > 0) {
            this.totalRecordCount = data.briefingReports[0].totalRecord;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); 
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

 

  transformDate(array) {
    if (array != null) {

      let dd = array.getDate().toString();
      if (parseInt(dd.toString()) < 10)
        dd = '0' + dd.toString();

      let mm = (array.getMonth() + 1).toString();
      if (parseInt(mm.toString()) < 10)
        mm = '0' + mm.toString();

      let hrs = array.getHours();
      if (parseInt(hrs.toString()) < 10)
        hrs = '0' + hrs.toString();

      let min = array.getMinutes()
      if (parseInt(min.toString()) < 10)
        min = '0' + min.toString();

      let sec = array.getSeconds()
      if (parseInt(sec.toString()) < 10)
        sec = '0' + sec.toString();

      return array.getFullYear() + '_' + mm + '_' + dd + '_' + hrs + '_' + min + '_' + sec;
    }
  }

  isDateFilter(dateArray: any) {
    this.rangeDates = dateArray;

    if (this.rangeDates != null) {
      if (this.rangeDates.length > 1) {
        let dd1 = this.rangeDates[0].getDate().toString();
        if (parseInt(dd1.toString()) < 10)
          dd1 = '0' + dd1.toString();

        let mm1 = (this.rangeDates[0].getMonth() + 1).toString();
        if (parseInt(mm1.toString()) < 10)
          mm1 = '0' + mm1.toString();

        let dd2 = this.rangeDates[1].getDate().toString();
        if (parseInt(dd2.toString()) < 10)
          dd2 = '0' + dd2.toString();

        let mm2 = (this.rangeDates[1].getMonth() + 1).toString();
        if (parseInt(mm2.toString()) < 10)
          mm2 = '0' + mm2.toString();

        this.fromDateFilter = this.rangeDates[0].getFullYear() + mm1 + dd1;
        this.toDateFilter = this.rangeDates[1].getFullYear() + mm2 + dd2;
      }
      if (this.fromDateFilter === null || this.fromDateFilter === '') {
        this.fromDateFilter = "null";
        this.toDateFilter = "null";
      }
    }
    else {
      this.fromDateFilter = "null";
      this.toDateFilter = "null";
    }
    if (this.fromDateFilter != 'null' && this.toDateFilter != 'null') {
      this.filterModel.fromDate = this.fromDateFilter;
      this.filterModel.toDate = this.toDateFilter;
      this.filterModel.pageNumber = '1';
      this.currentPage = 1;
      this.getBriefingProcessingReport();
    }

  }

  dateFilterClear() {
    this.rangeDates = [];
    this.fromDateFilter = null;
    this.toDateFilter = null;
    this.filterModel.fromDate = null;
    this.filterModel.toDate = null;    
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  setCurrentMonthDateRange() {
    const startOfMonth = moment().startOf('month').toDate();
    const endOfMonth = moment().endOf('month').toDate();
    this.rangeDates = [startOfMonth, endOfMonth];
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  onSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.filterModel.stateID = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  onFilterSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  onFilterDeSelectAllState($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    this.filterModel.stateID = this.listOfStateIds.join(',');
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.getBriefingProcessingReport();
  }

  sort(sortBy: any) {
    this.upDowEmailDateCSS = '';
    this.upDowTitleCSS = '';
    this.upDowSourceDateCSS = '';
    this.upDowAcquiredDateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "UpdateDate") {
        this.upDowEmailDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "SourceDate") {
        this.upDowSourceDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "AcquiredDate") {
        this.upDowAcquiredDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "UpdateDate") {
        this.upDowEmailDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "SourceDate") {
        this.upDowSourceDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "AcquiredDate") {
        this.upDowAcquiredDateCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.getBriefingProcessingReport();
  }


  exportToExcel() {
    this.getBriefingProcessingReportExport();
  }

  getBriefingProcessingReportExport() {
    this.listOfDataExport = [];
    this.isloading = true;
    this.filterModel.isExport=true;
    this.reportService.BriefingProcessingReportV2(this.tokenKey, this.filterModel).subscribe(data => {
      this.isloading = false;
      if (data) {
        if (data.status == "Success") {
          this.listOfDataExport = data.briefingReports;

          setTimeout(() => {
            if (this.listOfDataExport.length > 0) {
              var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
              let html = '<table>';
              html += document.getElementById("reportHeader").innerHTML + " " + document.getElementById("reportBody").innerHTML;
              html += "</table>";
              var ctx = { worksheet: 'Worksheet', table: html }
              let dt = this.transformDate(new Date());
              FileSaver.saveAs((uri + base64(format(template, ctx))), "BriefingReportExport_" + dt + ".xls");
            }
            else {
              this.toastrService.error("No record found", "error");
            }
          }, 1500);
        }
        else {
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloading = false;
    })
  }
}
